module.exports = __webpack_public_path__ + "media/packs/common/assets/images/mimamori/mimamori_e-a7d9c79a85f05dc849d523dd185881ba.png";